if (!customElements.get('plp-tabs')) {
  class PLPTabs extends HTMLElement {
    constructor() {
      super();

      this.tabLinks = this.querySelectorAll('[data-plp-tabs-selector-link]');
      this.tabSelect = this.querySelector('[data-plp-tabs-selector-option]');
      this.tabs = this.querySelectorAll('.tab-content');
    }

    connectedCallback() {
      this.tabLinks?.forEach(link => {
        link.addEventListener('click', this.handleLinkClick);
      });

      if (this.tabSelect) {
        this.tabSelect.addEventListener('change', this.handleSelectChange);
      }
    }

    disconnectedCallback() {
      this.tabLinks?.forEach(link => {
        link.removeEventListener('click', this.handleLinkClick);
      });

      if (this.tabSelect) {
        this.tabSelect.removeEventListener('change', this.handleSelectChange);
      }
    }

    handleLinkClick = (e) => { 
      e.preventDefault();
      const link = e.currentTarget;

      this.tabLinks?.forEach(l => {
        l.classList.remove('active');
      });

      this.tabs?.forEach(tab => {
        tab.classList.remove('open');
      });

      link.classList.add('active');

      const selector = link.getAttribute('data-tabcontent') || link.getAttribute('href');
      if (!selector) return;
      const targetTab = this.querySelector(selector);
      targetTab?.classList.add('open');

      // Scroll to the top of the tab content
      if (targetTab) {
        const rect = targetTab.getBoundingClientRect();
        const scrollTop = window.pageYOffset + rect.top;
        window.scrollTo({
          top: scrollTop - 100,
          behavior: 'smooth'
        });
      }

      // sync mobile select with clicked link
      if (this.tabSelect) {
        const idWithoutHash = selector.startsWith('#') ? selector.slice(1) : selector;
        if (this.tabSelect.value !== idWithoutHash) {
          this.tabSelect.value = idWithoutHash;
        }
      }
    }

    handleSelectChange = (e) => {
      const selectedId = e?.currentTarget?.value;
      if (!selectedId) return;

      // reset all
      this.tabLinks?.forEach(l => l.classList.remove('active'));
      this.tabs?.forEach(tab => tab.classList.remove('open'));

      const selector = `${selectedId}`;
      const targetTab = this.querySelector(selector);
      targetTab?.classList.add('open');

      // Scroll to the top of the tab content
      if (targetTab) {
        const rect = targetTab.getBoundingClientRect();
        const scrollTop = window.pageYOffset + rect.top;
        window.scrollTo({
          top: scrollTop - 100,
          behavior: 'smooth'
        });
      }

      const correspondingLink = this.querySelector(`[data-plp-tabs-selector-link][data-tabcontent='${selector}'], [data-plp-tabs-selector-link][href='${selector}']`);
      correspondingLink?.classList.add('active');
    }
  }
  customElements.define('plp-tabs', PLPTabs);
}